/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const SET_VIEW_SCREEN_LIST_ENTRY_POSITION = 'SET_VIEW_SCREEN_LIST_ENTRY_POSITION';
export const SET_LIST_ENTRY_PAGE = 'SET_LIST_ENTRY_PAGE';
export const LIST_SCREEN_UPDATE_CARET_VISIBLE = 'LIST_SCREEN_UPDATE_CARET_VISIBLE';
export const LIST_SCREEN_GHOST_HIGHLIGHT = 'LIST_SCREEN_GHOST_HIGHLIGHT';
export const LIST_SCREEN_LIMIT = 'LIST_SCREEN_LIMIT';
